import { useEffect } from "react";
import clsx from "clsx";
import { useActor } from "@xstate/react";
import { Navigate } from "react-router-dom";
import { AuthState } from "../../xstate/auth.machine";
import styles from "./Reports.module.scss";
import { Banners } from "../Banners/Banners";
import { NoData } from "../NoData/NoData";

// TODO: заменить на данные из API, когда появится эндпоинт отчётов
const reports = [
	{
		id: 1,
		period: "2026-09-01",
		status: { slug: "approve", i18n: "Принят" },
		points: 3000,
	},
	{
		id: 2,
		period: "2026-08-01",
		status: { slug: "approve", i18n: "Принят" },
		points: 500,
	},
	{
		id: 3,
		period: "2026-07-01",
		status: { slug: "approve", i18n: "Принят" },
		points: 0,
	},
];

const formatPeriod = date => {
	const month = new Date(date).toLocaleString("ru-RU", {
		month: "long",
		year: "numeric",
	});
	return month.charAt(0).toUpperCase() + month.slice(1);
};

export function Reports() {
	const [stateAuth] = useActor(AuthState);
	useEffect(() => {
		document.title = "Отчёты | Программа лояльности SK ZIC";
	}, []);

	// Страница только для выделенных дистрибьюторов
	if (
		stateAuth.context.type !== undefined &&
		stateAuth.context.subtype !== "dedicated_distributor"
	) {
		return <Navigate to="/account" replace />;
	}

	return (
		<>
			<section className={styles.workarea}>
				<div className="titleBlock">
					<h1>Отчёты</h1>
				</div>

				<div className="statContainer">
					<ReportsTable data={reports} />
				</div>
			</section>
			<aside className={styles.sidebar}>
				<Banners />
			</aside>
		</>
	);
}

function ReportsTable(props) {
	if (props.data.length === 0) {
		return <NoData />;
	}
	return (
		<div className="scrollbox">
			<table className="statTable">
				<thead>
					<tr>
						<th>Отчётный период</th>
						<th className={styles.status}>Статус</th>
						<th>Баллы</th>
					</tr>
				</thead>
				<tbody>
					{props.data.map(item => (
						<tr key={item.id}>
							<td>{formatPeriod(item.period)}</td>
							<td className={styles.status}>
								<span
									className={clsx(styles.stateValue, {
										[styles.stateDeclined]: item.status.slug === "reject",
										[styles.stateProcessing]: item.status.slug === "in_process",
										[styles.stateAccepted]: item.status.slug === "approve",
									})}
								>
									{item.status.i18n}
								</span>
							</td>
							<td>{item.points}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
